import { LinearProgress } from "@mui/material";
import React from "react";
import EventBus from "../eventbus/EventBus";

export const LoadingScreen = () => {
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
    }, [loading])

    React.useEffect(() => {
        const subscription1 = EventBus.subscribe("SHOW_LOADING", () => setLoading(true))
        const subscription2 = EventBus.subscribe("HIDE_LOADING", () => setLoading(false))

        return function cleanup() {
            subscription1.unsubscribe()
            subscription2.unsubscribe()
        }

    }, [])

    return (
        <>
            {loading && <LinearProgress sx={{height:"4px"}}/>}
        </>
    )
}